import authorizedAxios from "../../helpers/authorizedAxios";

export const SET_REPORTS_PURCHASES = "SET_REPORTS_PURCHASES";
export const SET_REPORTS_SALES = "SET_REPORTS_SALES";
export const SET_REPORTS_FINANCE_SUMMARY = "SET_REPORTS_FINANCE_SUMMARY";
export const SET_REPORTS_RECEIVABLES = "SET_REPORTS_RECEIVABLES";
export const SET_REPORTS_PAYABLES = "SET_REPORTS_PAYABLES";
export const SET_REPORTS_PURCHASES_TABLE = "SET_REPORTS_PURCHASES_TABLE";
export const SET_REPORTS_SALES_TABLE = "SET_REPORTS_SALES_TABLE";
export const SET_REPORTS_RECEIVABLES_TABLE = "SET_REPORTS_RECEIVABLES_TABLE";
export const SET_REPORTS_PAYABLES_TABLE = "SET_REPORTS_PAYABLES_TABLE";
export const SET_REPORTS_LOADING = "SET_REPORTS_LOADING";
export const SET_REPORTS_TABLE_LOADING = "SET_REPORTS_TABLE_LOADING";
export const SET_REPORTS_ERROR = "SET_REPORTS_ERROR";

const buildParams = (params = {}) =>
  Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ""));

const getExportErrorMessage = async (error) => {
  const responseData = error?.response?.data;

  if (responseData instanceof Blob) {
    const text = await responseData.text();

    try {
      const json = JSON.parse(text);
      return json?.message || "Gagal export laporan.";
    } catch (_err) {
      return text || "Gagal export laporan.";
    }
  }

  return responseData?.message || error?.message || "Gagal export laporan.";
};

export const fetchReportPurchase = (group_by, start_date, end_date) => {
  return async (dispatch) => {
    dispatch({ type: SET_REPORTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/reports/purchases", {
        params: buildParams({ group_by, start_date, end_date }),
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_REPORTS_PURCHASES,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_REPORTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data pengeluaran.",
      });
    } finally {
      dispatch({ type: SET_REPORTS_LOADING, status: false });
    }
  };
};

export const fetchFinanceSummary = (group_by, start_date, end_date) => {
  return async (dispatch) => {
    dispatch({ type: SET_REPORTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/reports/finance-summary", {
        params: buildParams({ group_by, start_date, end_date }),
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_REPORTS_FINANCE_SUMMARY,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_REPORTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil ringkasan keuangan.",
      });
    } finally {
      dispatch({ type: SET_REPORTS_LOADING, status: false });
    }
  };
};

export const fetchReportReceivable = (group_by, start_date, end_date) => {
  return async (dispatch) => {
    dispatch({ type: SET_REPORTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/reports/receivables", {
        params: buildParams({ group_by, start_date, end_date }),
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_REPORTS_RECEIVABLES,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_REPORTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data piutang.",
      });
    } finally {
      dispatch({ type: SET_REPORTS_LOADING, status: false });
    }
  };
};

export const fetchReportPayable = (group_by, start_date, end_date) => {
  return async (dispatch) => {
    dispatch({ type: SET_REPORTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/reports/payables", {
        params: buildParams({ group_by, start_date, end_date }),
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_REPORTS_PAYABLES,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_REPORTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data hutang.",
      });
    } finally {
      dispatch({ type: SET_REPORTS_LOADING, status: false });
    }
  };
};

export const fetchReportSale = (group_by, start_date, end_date) => {
  return async (dispatch) => {
    dispatch({ type: SET_REPORTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/reports/sales", {
        params: buildParams({ group_by, start_date, end_date }),
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_REPORTS_SALES,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_REPORTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data pendapatan.",
      });
    } finally {
      dispatch({ type: SET_REPORTS_LOADING, status: false });
    }
  };
};

export const fetchReportSalesTable = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_REPORTS_TABLE_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/reports/sales/table", {
        params: buildParams(params),
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_REPORTS_SALES_TABLE,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_REPORTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil table pendapatan.",
      });
    } finally {
      dispatch({ type: SET_REPORTS_TABLE_LOADING, status: false });
    }
  };
};

export const fetchReportPurchasesTable = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_REPORTS_TABLE_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/reports/purchases/table", {
        params: buildParams(params),
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_REPORTS_PURCHASES_TABLE,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_REPORTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil table pengeluaran.",
      });
    } finally {
      dispatch({ type: SET_REPORTS_TABLE_LOADING, status: false });
    }
  };
};

export const fetchReportReceivablesTable = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_REPORTS_TABLE_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/reports/receivables/table", {
        params: buildParams(params),
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_REPORTS_RECEIVABLES_TABLE,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_REPORTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil table piutang.",
      });
    } finally {
      dispatch({ type: SET_REPORTS_TABLE_LOADING, status: false });
    }
  };
};

export const fetchReportPayablesTable = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_REPORTS_TABLE_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/reports/payables/table", {
        params: buildParams(params),
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_REPORTS_PAYABLES_TABLE,
          data: response?.data?.data,
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_REPORTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil table hutang.",
      });
    } finally {
      dispatch({ type: SET_REPORTS_TABLE_LOADING, status: false });
    }
  };
};

export const exportBusinessReport = async ({ type = "sales", format = "xlsx", start_date, end_date }) => {
  try {
    const response = await authorizedAxios.get("/reports/export", {
      params: buildParams({ type, format, start_date, end_date }),
      responseType: "blob",
    });

    const contentDisposition = response.headers["content-disposition"] || "";
    const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
    const fileName = fileNameMatch?.[1] || `business-${type}-report.${format === "pdf" ? "html" : format}`;
    const blobUrl = URL.createObjectURL(new Blob([response.data], { type: response.headers["content-type"] }));

    if (format === "pdf") {
      const openedWindow = window.open(blobUrl, "_blank", "noopener,noreferrer");

      if (!openedWindow) {
        URL.revokeObjectURL(blobUrl);
        throw new Error("Popup browser memblokir preview PDF. Izinkan popup untuk membuka laporan.");
      }

      return fileName;
    }

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(blobUrl);

    return fileName;
  } catch (error) {
    throw new Error(await getExportErrorMessage(error));
  }
};
